<!--
 * @Author: yaoyuting
 * @Date: 2020-03-20 19:30:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-01 09:21:06
 * @Descripttion:
-->
<template>
  <div class="appcontent">
    <!-- <div class="footer" id="footer" ref="footer">
      <div class="footerbottom">
        <img class="bottomimg" src="@/assets/m/Index/logo.png" />
        <div class="bottombox">
          <img src="@/assets/m/Index/21.png" />
          2024 - FairCrypto Find, Lnc.
        </div>
        <div class="footermain">
          <div class="footermainl">
            <div class="div1">Invest Email :</div>
            <div class="div2">invest@faircrypto.org</div>
            <div class="div3">
              Strong Collaboration, Leading<br />
              the WEB3 Industry.
            </div>
            <div class="div4">
              Back to top <img src="@/assets/m/Index/22.png" />
            </div>
          </div>
          <div class="footermainr">
            <div>X</div>
            <div>Medium</div>
            <div>Youtube</div>
            <div>Mirror</div>
            <div>Telegram</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { GetEmail } from "@/assets/server/api";
export default {
  data() {
    return {
      timer: null, // 定时器名称
      ruleForm: { email: "" },
      rules: {
        email: [
          {
            required: true,
            type: "email",
            // message: "Please input email",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    // this.$bus.$emit("#footer");
  },
  methods: {
    async submitForm(formName) {
      var regEmail =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (formName != "") {
        if (formName != "" && !regEmail.test(formName)) {
          this.$message({
            message: "Email must be formatted correctly",
            type: "error",
          });
          this.ruleForm.email = "";
        } else {
          let formData = new FormData();
          let params = {
            email: this.ruleForm.email,
          };
          console.log("params", params);
          let item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          let data = await GetEmail(formData);
          this.$message({
            showClose: true,
            message: "Mailbox subscription succeeded",
            type: "success",
          });
          this.ruleForm.email = "";
        }
      } else {
        this.$message({
          message: "Please enter your e-mail address",
          type: "error",
        });
      }
    },
    goPage(url) {
      this.$router.push(url);
      this.show = false;
      this.shows1 = false;
      this.currentPath = url;
      sessionStorage.setItem("currentPath", url);
    },
    buildPage() {
      this.$message({
        message: "Coming Soon",
        type: "warning",
      });
    },
    jump(id) {
      var aa = document.querySelector(id);
      // console.log(id);
      this.timer = setTimeout(function () {
        document.querySelector(id).scrollIntoView(true);
      }, 100);

      this.$once("hook:beforeDestroy", () => {
        clearInterval(timer);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.appcontent {
  width: 750px;
  // margin: 120px auto 0px auto;
  background: #000;
  text-align: center;
  .footer {
    width: 690px;
    margin: 0 auto;
    // border: 1px solid red;
    background: #000;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    .footerbottom {
      margin-top: 120px;
      padding-bottom: 66px;
      text-align: left;
      .bottomimg {
        width: 338px;
        height: 52px;
      }
      .bottombox {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 28px;
        color: #ffffff;
        img {
          width: 30px;
          height: 30px;
          margin-top: 2px;
        }
      }
      .footermain {
        display: flex;
        justify-content: space-between;
        .footermainl {
          margin-top: 40px;
          .div1 {
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 28px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 42px;
          }
          .div2 {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 28px;
            color: #ffffff;
            line-height: 42px;
          }
          .div3 {
            margin-top: 42px;
            font-family: Poppins, Poppins;
            font-weight: 400;
            font-size: 24px;
            color: rgba(255, 255, 255, 0.8);
            line-height: 28px;
          }
          .div4 {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 28px;
            color: #ffffff;
            line-height: 42px;
            margin-top: 42px;
            img {
              width: 36px;
              height: 36px;
            }
          }
        }
        .footermainr {
          margin-right: 90px;
          margin-top: 40px;
          div {
            font-family: Poppins, Poppins;
            font-weight: 500;
            font-size: 28px;
            color: #ffffff;
            line-height: 42px;
            margin-bottom: 12px;
          }
        }
      }
    }
  }
}
</style>
